import { useRef } from "react";

const FileUploadButton = ({ setFile, file = {},field ,stateUpdateFunction}) => {
    let fileInput = useRef();

    function handleClick() {
        fileInput.current.click();
    }

    return (
        <div
            className="w-100 d-flex align-items-center flex-nowrap border rounded p-0 bg-white"
            style={{ overflow: "hidden", height: "2.25rem" }}
        >
            <input
                ref={fileInput}
                onChange={(e) => {
                    if (e.target.files.length > 0) {
                        setFile(e.target.files[0],field,stateUpdateFunction);
                    } else {
                        setFile(null,field,stateUpdateFunction);
                    }
                }}
                type="file"
                hidden
                required
            />

            <div className="flex-fill">
                <div
                    className="btn p-0 w-100 ms-2 text-start flex-fill border-0 text-nowrap"
                    style={{ overflow: "hidden", maxWidth: "20ch", textOverflow: "ellipsis" }}
                >
                    {file.name}
                </div>
            </div>

            <div
                onClick={handleClick}
                className="btn btn-primary text-start text-light border-0 p-1 px-2 d-flex align-items-center justify-content-center"
            >
                Upload
            </div>
        </div>
    );
};

export default FileUploadButton;
